import { type Common } from '../common.js';
import {
  type AppointmentReply,
  type AppointmentsResponse,
  type SafeAppointmentsResponse,
} from '../models/notification/intent.js';
import type * as Notification from '../models/patient/notification.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/patient-previsit/intents';
  }

  async getAppointments(args: {
    authenticationCode: string;
    safeData?: true;
    futureOnly?: boolean;
  }): Promise<SafeAppointmentsResponse>;
  async getAppointments(args: {
    authenticationCode: string;
    safeData: false;
    futureOnly?: boolean;
  }): Promise<AppointmentsResponse>;
  async getAppointments(args: {
    authenticationCode: string;
    futureOnly?: boolean;
    safeData?: boolean;
  }): Promise<SafeAppointmentsResponse | AppointmentsResponse> {
    const { authenticationCode, futureOnly = true, safeData } = args;
    const url = this.common.constructPath(`${this.baseEndpoint}/${authenticationCode}`, {
      futureOnly,
      safeData: safeData ?? true,
    });
    return await this.common.getJSON(url);
  }

  async postIntent(args: {
    intentId: string;
    kind: Notification.Kind;
    email?: string;
    phoneNumber?: string;
  }): Promise<{ message: string }> {
    if (!args.email && !args.phoneNumber) {
      throw new Error('At least email or phone number need to be provided.');
    }
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, args);
  }

  async processAppointmentsConfirmation({
    authenticationCode,
    appointmentReplies,
  }: {
    authenticationCode: string;
    appointmentReplies: AppointmentReply[];
  }): Promise<{
    success: boolean;
    successfullyProcessedIntentEncounterIds: string[];
  }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/v2/${authenticationCode}`);
    return await this.common.postJSON(url, { appointmentReplies });
  }
}
